module.exports = __webpack_public_path__ + "img/10.29e70cf5.jpg";